import { generateProductPath } from '../urlHelpers/products';

const basicUrlGenerate = (currentUrlState, filterName, value) => {
  try {
    const urlParams = { ...currentUrlState, [filterName]: value };
    return generateProductPath(urlParams, filterName);
  } catch (e) {
    return '#';
  }
};

const urlGenerator = (currentUrlState, filterName) => (page) => {
  return basicUrlGenerate(currentUrlState, filterName, page);
};

export { urlGenerator };
